import Container from '../../atoms/container/modalButtons';
import Focus from '../../../../shared/types/enums/focus';
import RestartButton from '../../atoms/buttons/modalRestart';
import TranslationManager from '../../../../shared/assets/locale/translationsManager';
import useKeyboard from '../../../../shared/components/utils/hooks/useKeyboard';
import {
  channelDown,
  channelUp,
} from '../../../../shared/store/thunks/channels.thunk';
import {
  retry,
  mediaSelector,
} from '../../../../shared/store/slices/media.slice';
import { clearModal } from '../../../../shared/store/slices/modal.slice';
import {
  popFocus,
  pushFocus,
} from '../../../../shared/store/slices/focus.slice';
import { useAppDispatch, useAppSelector } from '../../../../shared/store/hooks';
import { useCallback, useEffect, useRef } from 'react';
import { magicRemoteSelector } from '../../../../shared/store/slices/magicRemote.slice';
import { popRoute } from '../../../../shared/store/thunks/route.thunk';

function PlayerErrorModalButtons() {
  const dispatch = useAppDispatch();
  const { live } = useAppSelector(mediaSelector);
  const { enabled } = useAppSelector(magicRemoteSelector);

  const liveRef = useRef(live);
  liveRef.current = live;

  const retryPlayback = useCallback(() => {
    dispatch(clearModal());
    dispatch(retry());
  }, []);

  useEffect(() => {
    dispatch(pushFocus(Focus.MODAL_BUTTONS));
    return () => {
      dispatch(popFocus());
    };
  }, []);

  useKeyboard({
    focus: Focus.MODAL_BUTTONS,
    stopPropagation: true,
    keyDownHandler: (key: string) => {
      switch (key) {
        case 'BACK':
          dispatch(popRoute());
          break;
        case 'UP':
        case 'CHANNEL_UP':
          liveRef.current && dispatch(channelUp());
          break;
        case 'DOWN':
        case 'CHANNEL_DOWN':
          liveRef.current && dispatch(channelDown());
          break;
        case 'SELECT':
          retryPlayback();
          break;
      }
    },
  });

  return (
    <Container>
      <RestartButton focused={!enabled} onClick={() => retryPlayback()}>
        {TranslationManager.get('MODAL.PLAYER_ERROR.RESTART')}
      </RestartButton>
    </Container>
  );
}

export default PlayerErrorModalButtons;
